import { QueryResources } from 'datx-jsonapi-react';

import { EventAnnouncement } from '@/resources/EventAnnouncement';

export const queryEventAnnouncements = (eventId: string): QueryResources<EventAnnouncement> => {
  if (!eventId) return null;
  return [
    EventAnnouncement,
    {
      filter: {
        event_id: eventId,
      },
      sort: '-created_at',
      params: [
        {
          key: 'page[size]',
          value: '500',
        },
        {
          key: 'page[number]',
          value: '1',
        },
      ],
    },
  ];
};
